import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingBold: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M1.63.16h7.84a3.43 3.43 0 0 1 1.922 6.271A4.901 4.901 0 0 1 9.47 15.84H1.63z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingBold
